import { loadSignatures, type Signatures } from '@/components/timesheet/signatures';
import { useRelatedByIds } from './useRelatedByIds';

/**
 * Signatures des feuilles affichées (Validation, récapitulatif de l'Historique) : [timeSheetId => signatures], une
 * requête par type de signature pour la page. null pendant le chargement ; sans réponse (erreur), les cellules restent
 * vides. version : la changer recharge les signatures des mêmes feuilles (après une validation).
 */
export function useSignatures(sheetIds: number[], version = 0): Map<number, Signatures> | null {
  return useRelatedByIds(sheetIds, loadSignatures, version);
}
